import { action } from "typesafe-actions";
import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "..";
import { api } from "../../api/api";
import { IMasterStatus } from "./status.types";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";

import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";

export const FETCH_MASTER_STATUS_LIST_PROGRESS =
  "FETCH_MASTER_STATUS_LIST_PROGRESS";
export const FETCH_MASTER_STATUS_LIST_SUCCESS =
  "FETCH_MASTER_STATUS_LIST_SUCCESS";
export const FETCH_MASTER_STATUS_LIST_FAILED =
  "FETCH_MASTER_STATUS_LIST_FAILED";

export const FETCH_MASTER_STATUS_PROGRESS = "FETCH_MASTER_STATUS_PROGRESS";
export const FETCH_MASTER_STATUS_SUCCESS = "FETCH_MASTER_STATUS_SUCCESS";
export const FETCH_MASTER_STATUS_FAILED = "FETCH_MASTER_STATUS_FAILED";

// Action Creators
export const fetchMasterStatusListProgress = () =>
  action(FETCH_MASTER_STATUS_LIST_PROGRESS);
export const fetchMasterStatusListSuccess = (data: IMasterStatus[]) =>
  action(FETCH_MASTER_STATUS_LIST_SUCCESS, { data });
export const fetchMasterStatusListFailed = () =>
  action(FETCH_MASTER_STATUS_LIST_FAILED);

export const fetchMasterStatusProgress = () =>
  action(FETCH_MASTER_STATUS_PROGRESS);
export const fetchMasterStatusSuccess = (data: IMasterStatus) =>
  action(FETCH_MASTER_STATUS_SUCCESS, { data });
export const fetchMasterStatusFailed = () => action(FETCH_MASTER_STATUS_FAILED);

// Async Actions
export const fetchMasterStatusListAsync =
  (
    billing_company_uuid: string,
    pageNumber: number,
    rowsInPerPage: number,
    status: string,
    date?: IDataTableV2DateState["dates"],
    searchValue?: IDatatableV2AdvancedSearchFilter,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      let searchQuery = "";

      if (date && date.fromDate && date.toDate) {
        searchQuery += `&from_date=${date.fromDate}&to_date=${date.toDate}`;
      }

      dispatch(fetchMasterStatusListProgress());
      const res = await api.get(
        `/billing_company/get-master-status?billing_company_uuid=${billing_company_uuid}&pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}` +
          searchQuery,
      );
      const data: IMasterStatus[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchMasterStatusListSuccess(data));
    } catch (err: any) {
      dispatch(fetchMasterStatusListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const fetchMasterStatusAsync =
  (
    billing_company_uuid: string,
    statusUuid?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchMasterStatusProgress());
      dispatch(saveLoaderProgress());

      let url = `/billing_company/get-master-status?billing_company_uuid=${billing_company_uuid}`;

      if (statusUuid) {
        url += `&status_uuid=${statusUuid}`;
      }
      const res = await api.get(url);
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchMasterStatusSuccess(data[0]));
      } else {
        dispatch(fetchMasterStatusFailed());
      }
    } catch (err: any) {
      dispatch(fetchMasterStatusFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const upsertMasterStatusAsync =
  (
    data: IMasterStatus,
    onCallback: (isSuccess?: boolean, data?: IMasterStatus) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    dispatch(saveLoaderProgress());
    try {
      const payload = {
        master_status_uuid: data.master_status_uuid,
        name: data.name,
        description: data.description,
        billing_company_uuid: data.billing_company_uuid,
        status: data.status,
      };

      const res = await api.post(
        "/billing_company/upsert-master-status",
        payload,
      );

      dispatch(
        showMessage({
          type: "success",
          message: res.data.message,
          displayAs: "snackbar",
        }),
      );
      const responseData = res.data.data;
      onCallback(true, responseData);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

// export const FETCH_COMPANY_OUTLET_ENV_PROGRESS = "FETCH_COMPANY_OUTLET_ENV_PROGRESS";
// export const FETCH_COMPANY_OUTLET_ENV_SUCCESS = "FETCH_COMPANY_OUTLET_ENV_SUCCESS";
// export const FETCH_COMPANY_OUTLET_ENV_FAILED = "FETCH_COMPANY_OUTLET_ENV_FAILED";

// export const fetchCompanyOutletEnvProgress = () =>
// 	action(FETCH_COMPANY_OUTLET_ENV_PROGRESS);
// export const fetchCompanyOutletEnvSuccess = (data: IStatus) =>
// 	action(FETCH_COMPANY_OUTLET_ENV_SUCCESS, { data });
// export const fetchCompanyOutletEnvFailed = () =>
// 	action(FETCH_COMPANY_OUTLET_ENV_FAILED);

// 	export const fetchCompanyOutletEnvAsync =
// 	(comapny_outlet_uuid: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
// 	async (dispatch) => {
// 		try {
// 			dispatch(fetchCompanyOutletEnvProgress());
// 			dispatch(saveLoaderProgress());
// 			const res = await api.get(
// 				`/siteConfiguration/get-company-outlet-env?comapny_outlet_uuid=${comapny_outlet_uuid}`
// 			);
// 			const data = res.data.data;
// 			if (data.length > 0) {
// 				dispatch(fetchCompanyOutletEnvSuccess(data[0]));
// 			} else {
// 				dispatch(fetchCompanyOutletEnvFailed());
// 			}
// 		} catch (err: any) {
// 			dispatch(fetchCompanyOutletEnvFailed());
// 			dispatch(
// 				showMessage({
// 					type: "error",
// 					message: err.response.data.message,
// 					displayAs: "snackbar",
// 				})
// 			);
// 		} finally {
// 			dispatch(saveLoaderCompleted());
// 		}
// 	};

export const CLEAR_STATUS_STATE = "CLEAR_STATUS_STATE";
export const CLEAR_STATUS = "CLEAR_STATUS";
export const CLEAR_MASTER_STATUS_STATE = "CLEAR_MASTER_STATUS_STATE";
export const CLEAR_MASTER_STATUS = "CLEAR_MASTER_STATUS";

export const clearStatusState = () => action(CLEAR_STATUS_STATE);
export const clearStatus = () => action(CLEAR_STATUS);
export const clearMasterStatusState = () => action(CLEAR_MASTER_STATUS_STATE);
export const clearMasterStatus = () => action(CLEAR_MASTER_STATUS);
